import React from "react";
import { url } from "../apis/apiSetup";

const casLogin = () => {
  // if (process.env.NODE_ENV === "development") {
  //   window.location.href = `${url}/cas/login?service_frontend_url=http://127.0.0.1:3000`;
  // } else {
    window.location.href = `${url}/cas/login?service_frontend_url=${window.location.origin}`;
  // }

  return null;
};

export default casLogin;
